import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const processDataValue = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    name: z
      .string()
      .nullable()
      .optional()
      .requiredFinal()
      .describe('Value name'),

    stringValue: z.string().nullable().optional().describe('String value'),

    numberValue: z.number().nullable().optional().describe('Number value'),

    booleanValue: z.boolean().nullable().optional().describe('Boolean value'),

    sequence: z
      .number()
      .nullable()
      .optional()
      .hidden()
      .describe('Display order'),

    dataTypeId: z.uuid().hidden().describe('Foreign key to ProcessDataType'),

    dataType: belongsTo('ProcessDataType'),
  })
  .describe('A valid value for a native data type.')
  .as('ProcessDataValue');

export { processDataValue as processDataValueSchema };
